// extracted by mini-css-extract-plugin
export var container = "SOS-module--container--CrWS4";
export var img = "SOS-module--img--URdnU";